/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_TitleInputs */



/**
* | output |
* | --- |
* | "Start with one conversation" |
*
* @param {Onboarding_First_Meeting_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_title = /** @type {((inputs?: Onboarding_First_Meeting_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Begin met één gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencez par une seule conversation")
	return /** @type {LocalizedString} */ ("Start with one conversation")
});